export enum DealStatus {
  Negotiation = 1,
  Accepted = 2,
  Rejected = 3,
  InProgress = 4,
  Completed = 5,
}
